import { Box, ColorOptions, Icon, IconNewOptions, ModBox, SpacerNew, Text, TextNew } from '@jfs/ui-new'
import React, { useEffect, useState } from 'react'
import { Dimensions } from 'react-native'
import { FIELD_ERROR_STYLE, FIELD_LABEL_STYLE, TextInputNew } from '../AdminInputs'
import { DefaultDropDown } from './DefaultDropDown'
import { DropDownBox } from './DropDownBox'
import { defaultButtonLabel, defaultSelectedFileType, dropdownPlacementTopValue } from './DropdownConstants'
import { renderPortal } from './DropdownPotal'
import { RadioButtonDropdown } from './RadioButtonDropdown'
import { styles } from './styles'
import { DropDownProps, DropdownTypes, itemSelected } from './types'

const rightComp = <Icon id={'SEARCH'} color={'PRIMARY_GREY'} />
const zIndex = 999999 //This high value because modal too has some zindex due to which it gets hidden when opent in modal.
//const customRange = 'Custom Range'
const DropdownOptimised: React.FC<DropDownProps> = ({
  placeHolder,
  onChange,
  data,
  type = DropdownTypes.DEFAULT_WITH_IMAGE,
  hide = false,
  buttonLabel = defaultButtonLabel,
  iconType = null,
  onButtonPress,
  title = '',
  dropDownContentFontSize,
  chevronColor,
  setFieldValue,
  label,
  fieldName,
  disabled = false,
  error,
  touched,
  testID,
  textColor,
  showSearch = false,
  marginTop,
  maxHeight,
  labelStyle = {},
  ...props
}: DropDownProps) => {
  const [dropdownVisible, toggleDropdown] = useState(false)
  const [value, setValue] = useState(props.value ?? placeHolder)
  const [dropdownData, setDropdDownData] = useState(data)
  const [fileFormatType, updateFileFormat] = useState(defaultSelectedFileType)
  const [layoutValue, onLayout] = useState({ left: 0, top: 0, width: undefined })
  const [searchString, setSearchString] = useState('')

  const isExportType = type === DropdownTypes.RADIO_BUTTON

  const onDropdownItemPress = (item: itemSelected) => {
    const selectedValue = item?.value ?? ''
    /*   if (selectedValue === customRange) {
      updateLabel('')
    } else {
      updateLabel(item?.value)
    } */
    toggleDropdown(!dropdownVisible)
    setValue(selectedValue)
    onChange(selectedValue)
    if (fieldName && setFieldValue) {
      setFieldValue(fieldName, selectedValue)
    }
  }

  const clearSelection = () => {
    // updateLabel(title)
    toggleDropdown(false)
    onChange('')
  }

  const handleDownload = (): void => {
    toggleDropdown(!dropdownVisible)
    if (onButtonPress) {
      onButtonPress(fileFormatType)
    }
  }

  const onSearch = (val: string) => {
    setSearchString(val)
    const searchData = data?.filter((item: any) => item.value?.toLowerCase()?.includes(val?.toLowerCase()))
    setDropdDownData(searchData)
  }

  const renderDropDown = (): React.ReactElement => {
    return (
      <ModBox {...styles.modal} zIndex={zIndex} onPress={() => [toggleDropdown(false)]} show={data && dropdownVisible}>
        <Box
          {...styles.dropdownContainer}
          width={layoutValue.width}
          left={type === DropdownTypes.DEFAULT_WITH_BG ? layoutValue?.left - 8 : layoutValue?.left}
          top={layoutValue?.top}
          pb={type === DropdownTypes.DEFAULT_WITH_IMAGE ? 0 : 5}>
          <ModBox
            show={type === DropdownTypes.DEFAULT_WITH_BG}
            p={16}
            borderBottomWidth={1}
            w={210}
            borderBottomColor={'LIGHTEST_GREY_2'}>
            <Text
              fontSize={12}
              color={'#A0A0A0' as ColorOptions}
              letterSpacing={1.2}
              fontFamily={'jiotype-medium'}
              title={'CHOOSE A FILTER'}
            />
          </ModBox>
          <ModBox show={showSearch && data?.length > 10}>
            <TextInputNew
              value={searchString}
              onChangeText={onSearch}
              padding={8}
              borderColor={'DISABLED_GREY'}
              borderRadius={4}
              placeholder={'Search'}
              autoFocus={true}
              fontSize={14}
              placeholderTextColor={'PRIMARY_GREY'}
              rightComponent={rightComp}
            />
          </ModBox>
          <DefaultDropDown
            data={dropdownData}
            isExportType={isExportType}
            onDropdownItemPress={onDropdownItemPress}
            selectedValue={type === DropdownTypes.DEFAULT_WITH_BG ? '' : placeHolder}
            fontSize={dropDownContentFontSize}
            maxHeight={Dimensions.get('window').height - layoutValue?.top - dropdownPlacementTopValue - 60}
          />
          <RadioButtonDropdown
            data={dropdownData}
            isExportType={isExportType}
            fileFormatType={fileFormatType}
            updateFileFormat={updateFileFormat}
            handleDownload={handleDownload}
            buttonLabel={buttonLabel}
            downloadBtntestID={'downloadBtn'}
          />
        </Box>
      </ModBox>
    )
  }

  useEffect(() => {
    setValue(props.value ?? placeHolder)
    setDropdDownData(data)
  }, [data, placeHolder, props.value])

  const showBorder = type !== DropdownTypes.DEFAULT_WITHOUT_BORDER && type !== DropdownTypes.DEFAULT_WITH_BG

  if (hide) {
    return null
  } else {
    const isIconAvailable = iconType !== null
    return (
      <Box marginTop={marginTop}>
        <ModBox show={!!label}>
          <TextNew {...labelStyle} {...FIELD_LABEL_STYLE} title={label} lineHeight={20} />
          <SpacerNew size={8} />
        </ModBox>
        <DropDownBox
          testID={testID}
          showBorder={showBorder}
          isIconAvailable={isIconAvailable}
          onLayout={onLayout}
          toggleDropdown={toggleDropdown}
          iconType={iconType as IconNewOptions}
          defaultLabel={type !== DropdownTypes.DEFAULT_WITH_IMAGE_DOWNLOAD_REPORT ? value || title : title}
          dropdownVisible={dropdownVisible}
          type={type}
          value={value}
          clearSelection={clearSelection}
          chevronColor={chevronColor}
          disabled={disabled}
          textColor={
            textColor ??
            (type === DropdownTypes.DEFAULT_WITH_BG || (value && value !== placeHolder)
              ? undefined
              : ('#bfbfbf' as ColorOptions))
          }
        />
        {renderPortal(renderDropDown)}
        {touched && !!error && (
          <>
            <SpacerNew size={2} />
            <TextNew testID={'textInputErrorId'} {...FIELD_ERROR_STYLE}>
              {error}
            </TextNew>
          </>
        )}
      </Box>
    )
  }
}

export { DropdownOptimised }
